const state = () => ({
  isValid: false,
  companyEmployees: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  companyEmployees(state) {
    return state.companyEmployees;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateCompanyEmployees(state, payload) {
    state.companyEmployees = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  updateCompanyEmployees({ commit }, payload) {
    commit('updateCompanyEmployees', payload);
  }
};

export const companyEmployees = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
